module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-expandable-own-right.d42f06e0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-expandable-own-right.png
// module id = 3839
// module chunks = 11